module.exports = __webpack_public_path__ + "img/gold12.249c635d.gif";